export const supportConfig = {
  companyName: 'ARWAESDIGITAL LTD',
  name: 'gameskinx',
  descriptor: 'gameskinx',
  supportEmail: 'support@gameskinx.com',
  emailContent: 'content@gameskinx.com',
  emailCareer: 'careers@gameskinx.com',
  emailPrivacy: 'privacy@gameskinx.com',
  emailLegal: 'legal@gameskinx.com',
  website: 'https://gameskinx.com',
  phone: '+37256996644',
  registrationNumber: 'НЕ 465235',
  addressInfo: {
    zip: 1065,
    country: 'Cyprus',
    city: 'Nicosia',
    region: 'Harju maakond',
    address: 'Giannou Kranidioti & Pargas, 9 1st floor, Flat/Office 102',
  },
}

export default supportConfig
